import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import CategoriesDropdown from "../selectDropdown/CategoriesDropdown";
import {
  globalConstants,
  categoryDropdownConstants,
  EMPTY_STRING,
} from "../../../constants";
import {
  getCustomCategoriesOptionList,
  getCustomSubCategoriesOptionList,
  getCustomTypesOptionList,
  getDefaultFilterCategory,
  getDefaultFilterType,
} from "../../utility";

const FilterDropdowns = (props) => {
  //-------props
  const {
    customTypes,
    customCategories,
    customSubCategories,
    setSearchProductType,
    setSearchProductCategory,
    setSearchProductSubCategory,
    defaultProductType = {},
    isDisabledAll = false,
    gridState = false,
    setGridState = () => {},
    scrollRef = null,
    gridRef = null,
  } = props;
  //-------Usestate
  const [productType, setProductType] = useState(
    getDefaultFilterType(customTypes, defaultProductType)
  );
  const [productCategory, setProductCategory] = useState(EMPTY_STRING);
  const [productSubCategory, setProductSubCategory] = useState(EMPTY_STRING);

  // reset the scroll and page on update of any filter (as updating type, category also cause an update for subcategory)
  const handleCallBackOfFiltersUpdate = () => {
    setGridState((gridState) => ({ ...gridState, pageIndex: 1 }));
    if (
      scrollRef?.current &&
      gridRef?.current?.api?.gridBodyCtrl?.eBodyViewport?.scrollTop
    ) {
      scrollRef.current = 0;
      gridRef.current.api.gridBodyCtrl.eBodyViewport.scrollTop = 0;
    }
  };

  useEffect(() => {
    setProductType(getDefaultFilterType(customTypes, defaultProductType)); // eslint-disable-next-line
  }, [customTypes]);

  useEffect(() => {
    if (gridState) {
      setProductType(
        getDefaultFilterType(
          customTypes,
          gridState?.productType || defaultProductType
        )
      );
      setProductCategory(
        getDefaultFilterCategory(
          customCategories,
          gridState?.productCategory
        ) || ""
      );
      setProductSubCategory(
        getDefaultFilterCategory(
          customSubCategories,
          gridState?.productSubCategory
        ) || ""
      );
    }
  }, [gridState]);

  return (
    <Row className="m-0 w-100">
      <Col md={4} className=" pe-md-0 ps-md-0">
        <CategoriesDropdown
          options={getCustomTypesOptionList(customTypes)}
          handleChange={(selectedOption) => {
            setProductType(selectedOption);
            setSearchProductType(selectedOption);
            setProductCategory(EMPTY_STRING);
            setProductSubCategory(EMPTY_STRING);
            setSearchProductCategory(EMPTY_STRING);
            setSearchProductSubCategory(EMPTY_STRING);
            handleCallBackOfFiltersUpdate();
          }}
          label="Type"
          value={productType}
          noOptionsMessage="No Type Found"
          placeholder="Type"
          SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
          isClearable={false}
          disabled={isDisabledAll}
        />
      </Col>
      <Col md={4} className=" pe-md-0">
        <CategoriesDropdown
          options={getCustomCategoriesOptionList(
            customCategories,
            productType.value,
            productType.label
          )}
          label="Category"
          value={productCategory}
          handleChange={(selectedOption) => {
            setProductCategory(selectedOption || EMPTY_STRING);
            setSearchProductCategory(selectedOption || EMPTY_STRING);
            setProductSubCategory(EMPTY_STRING);
            setSearchProductSubCategory(EMPTY_STRING);
            handleCallBackOfFiltersUpdate();
          }}
          noOptionsMessage="No Category Found"
          placeholder="Category"
          SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
          disabled={isDisabledAll}
        />
      </Col>
      <Col md={4} className=" pe-md-0">
        <CategoriesDropdown
          options={getCustomSubCategoriesOptionList(
            customSubCategories,
            productCategory?.value,
            productType.label,
            productType.value,
            false,
            customCategories
          )}
          label="Sub-Category"
          value={productSubCategory}
          handleChange={(selectedOption) => {
            setProductSubCategory(selectedOption || EMPTY_STRING);
            setSearchProductSubCategory(selectedOption || EMPTY_STRING);
            handleCallBackOfFiltersUpdate();
          }}
          noOptionsMessage="No SubCategory Found"
          placeholder="Sub-Category"
          SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
          disabled={isDisabledAll}
        />
      </Col>
    </Row>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(FilterDropdowns);
